<div class="row justify-content-center">
  <div class="col">
    <img alt="" class="d-block udex-mx-auto udex-mb-40" [src]="imgPath" />
  </div>
</div>
<div *ngIf="!titleDisplay" class="row text-center justify-content-center">
  <h3 class="heading__medium--xs udex-mb-20">
    {{ headline | cxTranslate }}
  </h3>
</div>
